import React from "react";
import MiniDrawer from "./Drawer/Menu/Menu";
import AppRoutes from "./Drawer/Routes";
import { Box } from "@mui/material";
import MainLayout from "./Pages/Main";
import { BASENAME } from "./config";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginProvider from "./Pages/Login/LoginProvider";
import withAppProviders from "./withAppProviders";
import { VendorAuthProvider } from "./Pages/VendorPortal/VendorAuthContext";
import VendorRoutes from "./Pages/VendorPortal/VendorRoutes";

const App: React.FC = () => {
  return (
    <Box data-testid="pos-ui-app">
      <MainLayout>
        <BrowserRouter basename={BASENAME}>
          <Routes>
            {/* Vendor Portal — separate route tree, own layout + auth */}
            <Route
              path="/vendor/*"
              element={
                <VendorAuthProvider>
                  <VendorRoutes />
                </VendorAuthProvider>
              }
            />

            {/* Main admin app — everything else */}
            <Route
              path="/*"
              element={
                <LoginProvider>
                  <Box>
                    <MiniDrawer>
                      <AppRoutes />
                    </MiniDrawer>
                  </Box>
                </LoginProvider>
              }
            />
          </Routes>
        </BrowserRouter>
      </MainLayout>
    </Box>
  );
};

export default withAppProviders(App);
